<template lang="pug">
b-modal#editTheme(
  ref="editTheme"
  :title="$t('ui.combine.edit_theme')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$tc('ui.theme_provider')" disabled).mb-1
      ThemeProviderTypeLookup(
        ref="provider_type"
        size="sm"
        required
        type="array"
        :disabled="loading"
        :dirty="$v.provider_type.$dirty"
        :error="$v.provider_type.$error"
        v-model.trim.lazy="$v.provider_type.$model"
      )
      ValidateResult(:value="$v.provider_type" :name="$t('ui.theme_provider')")
    b-form-group(:label="$tc('ui.theme_code')" disabled).mb-1
      DebounceInput(
        size="sm"
        ref="theme_code"
        required
        type="text"
        :dirty="$v.theme_code.$dirty"
        :error="$v.theme_code.$error"
        v-model.trim.lazy="$v.theme_code.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.theme_code" :name="$t('ui.theme_code')")
    b-form-group(:label="$t('ui.theme_name')").mb-1
      DebounceInput(
        size="sm"
        ref="theme_name"
        required
        type="text"
        :dirty="$v.theme_name.$dirty"
        :error="$v.theme_name.$error"
        v-model.trim.lazy="$v.theme_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.theme_name" :name="$t('ui.theme_name')")
    b-form-group(:label="$t('ui.status')").mb-1
      label.custom-switch
        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="isEnable")
        span.custom-switch-indicator

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import ThemeProviderTypeLookup from "@/library/ThemeProviderTypeLookup";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    ThemeProviderTypeLookup
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      provider_type: '',
      theme_name: '',
      theme_code: '',
      isEnable: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    provider_type: {
      required
    },
    theme_name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    theme_code: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    }
  },
  methods: {
    done(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editThemeUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          provider_type: this.provider_type,
          theme_code: this.theme_code,
          theme_name: this.theme_name,
          enable: this.isEnable
        };
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_theme", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editTheme.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editTheme.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.provider_type = "";
      this.theme_name = "";
      this.theme_code = "";
    },
    shown() {
      this.$v.$reset();
      this.provider_type = this.item.provider_type;
      this.theme_name = this.item.theme_name;
      this.theme_code = this.item.theme_code;
      this.isEnable = this.item.enable;
      this.$refs.theme_name.$el.focus();
    }
  }
};
</script>
